var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOtherPets = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.014 10.51c-.2-1-.2-1.9.1-2 .5-.2 3.1 2.7 3.6 4.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.214 17.11c-1.3-2.1-1.7-3.8-3.7-3.8-.5 0-1.1.1-1.5.3-.6-1.7-3.3-4.7-3.7-4.5-.7.5 0 5.2 1.7 6.4q-.3.75-.3 1.5c0 2.1 1.7 3.8 3.7 3.8s4.9-1.9 3.8-3.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.614 15.21a.7.7 0 1 1 0 1.399.7.7 0 0 1 0-1.4ZM29.214 17.11l-.8.3s0 .9.9 1.1l.1-.1c0-.3.1-.8-.2-1.3Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.214 17.11-.8.2s.1.9 1 1c0 0 .1-.6-.2-1.2ZM22.314 19.11l-.1.2s-12 .7-10.3 10.6c0 0 .7 2.3 3 2.5 0 0 2.4.099 2.9.3.8.4 2.9.1 2.9.1.6-.1.9-.4.9-.801 0-.599-1-.799-2.2-1 1.5-.599 3.5-1.599 4.3-2.099 0 0-.4 2.9 1.2 3.7 0 0 1.7.6 2.2-.101 0 0 .5-1.099-.8-1.199-.3 0-1.2.6-1-.9 0 0 2.3-5.5 2-9.1v-.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.814 30.01c-.1 0-.3-.1-.4-.2-.8-.4-1.1-1.2-.8-1.7.2-.3.6-.5 1.1-.5M19.314 31.11s3.4-4.7-2.8-6.2"
}))));
export default SvgOtherPets;